export default class Entita{
    IdEntita;
    CodiceEntita;
    CodiceStato;
    Stato;
    IdCompany;
    Descrizione;
    IdAzienda;
    Commessa;
    DataInstallazione;
    DataDismissione;
    CodiceSito;
    CodiceUnita;
    CodiceFamiglia;
    CodiceSottoFamiglia;
    Marca;
    Modello;
    Matricola;
    DataFabbricazione;
    IdFornitore;
    DescrizioneUnita;
    Identificativo;
    SysChiaveglobale;

    constructor(){}
}